import styled from 'styled-components'
import { Field as DefaultField, Title as DefaultTitle } from '~components'

export const Field = styled(DefaultField)`
  & > input {
    text-transform: uppercase;
  }
`

export const Title = styled(DefaultTitle)`
  margin-bottom: ${({ theme }) => theme.spacing.km8};
`
